import React from "react";
import NewPurchase from "./NewPurchase";

const NewPurchaseMain = () => {
  return (
    <div>
      <NewPurchase salesReturn={false}></NewPurchase>
    </div>
  );
};

export default NewPurchaseMain;
